module.exports = __webpack_public_path__ + "img/action-RNY.efa58f91.svg";